import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ArchiveClassroomReveal from './classroom/reveal/ArchiveClassroomReveal';
import AddClassroomReveal from './classroom/reveal/AddClassroomReveal';
import EnrollClassroomReveal from './classroom/reveal/EnrollClassroomReveal';
import SubmitTaskDataReveal from './classroom/reveal/SubmitTaskDataReveal';
import EditRoleClassroomReveal from './classroom/reveal/EditRoleClassroomReveal';
import AddGroupReveal from './classroom/reveal/AddGroupReveal';
import RemoveBookReveal from './classroom/reveal/RemoveBookReveal';
import RemoveStudentReveal from './classroom/reveal/RemoveStudentReveal';
import RemoveAssignmentReveal from './assignments/reveal/RemoveAssignmentReveal';
import RemoveGroupReveal from './classroom/reveal/RemoveGroupReveal';
import EditGroupReveal from './classroom/reveal/EditGroupReveal';
import ClassCodeReveal from './common/reveal/ClassCodeReveal';
import InactivityReveal from './classroom/reveal/InactivityReveal';
import CopyBookReveal from './book/reveal/CopyBookReveal';
import ReDownloadBookReveal from './classroom/reveal/ReDownloadBookReveal/ReDownloadBookReveal';
import ImportStudentsReveal from './classroom/reveal/ImportStudentsReveal';
import RemoveDiscussionReveal from './discussions/RemoveDiscussionReveal';
import CloseDiscussionReveal from './discussions/CloseDiscussionReveal';
import DesynchronizeBookReveal from './book/desynchronizeBook/DesynchronizeBookReveal';
import { DESYNCHRONIZE_BOOK_REVEAL } from './book/desynchronizeBook/DesynchronizeBookReveal';
import DesynchronizeActivityReveal from './book/desynchronizeBook/DesynchronizeActivityReveal';
import { DESYNCHRONIZE_ACTIVITY_REVEAL } from './book/desynchronizeBook/DesynchronizeActivityReveal';
import FailImportStudentsReveal from './classroom/reveal/FailImportStudentsReveal';
import DisableEvaluationsReveal from './common/reveal/DisableEvaluationsReveal';
import StudentsWithFilesReveal from './common/reveal/StudentsWithFilesReveal';
import AssignmentsContentPanelModal from './drawer-contents/AssignmentsContentPanel/AssignmentsContentPanelModal';
import AssignmentsContentPanelModalNoGroups from './drawer-contents/AssignmentsContentPanel/AssignmentsContentPanelModalNoGroups';
import NotCanUploadFilesReveal from './classroom/reveal/NotCanUploadFilesReveal';
import DisableCommentReveal from './common/reveal/DisableCommentReveal';
import CustomConfirmModal from './classroom/reveal/CustomConfirmModal';
import PictogramConfigReveal from './classroom/reveal/PictogramConfigReveal';
import LinkedBookModal from './classroom/reveal/LinkedBookModal';
export const RevealsContainer = ({
  addModalIsOpen,
  classCodeIsOpen,
  removeDiscussionRevealIsOpen,
  closeDiscussionRevealIsOpen,
  unenrollUserRevealIsOpen,
  commonRevealOpened,
  disableEvaluationsRevealOpen,
  studentsWithFilesRevealOpen,
  studentsWithoutAssignmentInLessons,
  tskWithoutStudentsOfThisGroup,
  disableCommentRevealOpen,
  customConfirmModalObject,
  linkedBookModalObject
}) => {
  return (
    <div className="reveals-container">
      <ArchiveClassroomReveal />
      {addModalIsOpen && <AddClassroomReveal />}
      {classCodeIsOpen && <ClassCodeReveal />}
      {removeDiscussionRevealIsOpen && <RemoveDiscussionReveal />}
      {closeDiscussionRevealIsOpen && <CloseDiscussionReveal />}
      {disableEvaluationsRevealOpen && <DisableEvaluationsReveal />}
      {disableCommentRevealOpen && <DisableCommentReveal />}
      {studentsWithFilesRevealOpen && <StudentsWithFilesReveal />}
      {studentsWithoutAssignmentInLessons && <AssignmentsContentPanelModal />}
      {tskWithoutStudentsOfThisGroup && <AssignmentsContentPanelModalNoGroups />}
      {customConfirmModalObject && customConfirmModalObject.opened && <CustomConfirmModal />}
      <EnrollClassroomReveal />
      <SubmitTaskDataReveal />
      <EditRoleClassroomReveal />
      <AddGroupReveal />
      <RemoveBookReveal />
      <CopyBookReveal />
      {commonRevealOpened === DESYNCHRONIZE_BOOK_REVEAL && <DesynchronizeBookReveal />}
      {commonRevealOpened === DESYNCHRONIZE_ACTIVITY_REVEAL && <DesynchronizeActivityReveal />}
      {unenrollUserRevealIsOpen && <RemoveStudentReveal />}
      <RemoveAssignmentReveal />
      <RemoveGroupReveal />
      <EditGroupReveal />
      <InactivityReveal />
      <FailImportStudentsReveal />
      <ReDownloadBookReveal />
      <ImportStudentsReveal />
      <NotCanUploadFilesReveal />
      <PictogramConfigReveal />
      {linkedBookModalObject && linkedBookModalObject.opened && <LinkedBookModal />}
    </div>
  );
};

RevealsContainer.propTypes = {
  addModalIsOpen: PropTypes.bool,
  classCodeIsOpen: PropTypes.bool,
  closeDiscussionRevealIsOpen: PropTypes.bool,
  removeDiscussionRevealIsOpen: PropTypes.bool,
  unenrollUserRevealIsOpen: PropTypes.bool,
  submitTaskDataIsOpen: PropTypes.bool,
  commonRevealOpened: PropTypes.any,
  disableEvaluationsRevealOpen: PropTypes.bool,
  studentsWithFilesRevealOpen: PropTypes.bool,
  studentsWithoutAssignmentInLessons: PropTypes.bool,
  tskWithoutStudentsOfThisGroup: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    commonRevealOpened: state.reveal.openedReveal,
    addModalIsOpen: state.classrooms.addModalIsOpen,
    classCodeIsOpen: state.classrooms.selectedClassroom.classCodeIsOpen,
    removeDiscussionRevealIsOpen: state.discussions.removeReveal.isOpen,
    closeDiscussionRevealIsOpen: state.discussions.closeReveal.isOpen,
    unenrollUserRevealIsOpen: state.classrooms.unenrollModalIsOpen,
    submitTaskDataIsOpen: state.classrooms.submitTaskDataIsOpen,
    disableEvaluationsRevealOpen: state.reveal.disableEvaluationsRevealOpen,
    disableCommentRevealOpen: state.reveal.disableCommentRevealOpen,
    studentsWithFilesRevealOpen: state.reveal.studentsWithFilesRevealOpen,
    studentsWithoutAssignmentInLessons: state.reveal.studentsWithoutAssignmentInLessons,
    tskWithoutStudentsOfThisGroup: state.reveal.tskWithoutStudentsOfThisGroup,
    customConfirmModalObject: state.reveal.customConfirmModalObject,
    linkedBookModalObject: state.reveal.linkedBookModalObject
  };
}

export default connect(mapStateToProps)(RevealsContainer);
